import { useState } from "react";
import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Lock, Visibility, VisibilityOff } from "@mui/icons-material";

export default function PasswordField({
  label = "Senha",
  required = false,
  value,
  onChange,
  error = false,
  helperText,
  autoComplete = "current-password",
  autoFocus = false,
  disabled = false,
  name = "password",
}) {
  const [visible, setVisible] = useState(false);
  const inputId = `auth-${name}`;

  return (
    <Box sx={{ mb: helperText ? 1 : 1.5 }}>
      <Typography
        component="label"
        htmlFor={inputId}
        sx={(theme) => ({
          color: theme.palette.text.primary,
          display: "block",
          fontSize: theme.typography.body2.fontSize,
          fontWeight: 500,
          lineHeight: "20px",
          mb: 0.75,
        })}
      >
        {label}
        {required ? " *" : ""}
      </Typography>

      <TextField
        id={inputId}
        name={name}
        type={visible ? "text" : "password"}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        disabled={disabled}
        error={error}
        helperText={helperText}
        fullWidth
        required={required}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Lock fontSize="small" />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={visible ? "Ocultar senha" : "Mostrar senha"}
                disabled={disabled}
                edge="end"
                onClick={() => setVisible((current) => !current)}
                size="small"
              >
                {visible ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
}
